import { useTranslation } from 'react-i18next';

import { ErrorMessage, Loading, withValidPermission } from '@Components';
import { useFetchData } from '@CustomHooks';
import { IntegrationPagination, Permission } from '@Models';
import { bopsApi } from '@Network';
import Integrations from './integrations';

const IntegrationsContainer = () => {
  const { t } = useTranslation();

  interface FetchDataResult {
    data: IntegrationPagination | undefined;
    isLoading: boolean;
    error: string | null;
  }

  // Initial load with include_filter_options to get filter options
  const {
    data: dataIntegrations,
    isLoading: isLoadingIntegrations,
    error: errorsIntegrations,
  }: FetchDataResult = useFetchData(() => bopsApi.getIntegrations('include_filter_options=true', 1, 9, null, null));

  if (isLoadingIntegrations) return <Loading title={t('Integration.Loading')} />;

  if (errorsIntegrations || !dataIntegrations) {
    return <ErrorMessage internalMessage="Unable to get integrations" />;
  }

  // Provide default filter options if not present in response
  const initialFilterOptions = dataIntegrations.filter_options ?? {
    clients: [],
    file_types: [],
    connector_types: [],
  };

  return (
    <Integrations
      integrations={dataIntegrations.items}
      total={dataIntegrations.total}
      initialFilterOptions={initialFilterOptions}
    />
  );
};

export default withValidPermission(IntegrationsContainer, Permission.ManageIntegrations);
